/* LINTEL — Incline Stretch Board PDP: gallery, set cards, bundle, carousels, videos, scroll-to-buy */
(function () {
  var root = document.querySelector('[data-lnb]');
  if (!root) return;

  /* gallery */
  var track = root.querySelector('[data-lnb-track]');
  var slides = track ? Array.prototype.slice.call(track.querySelectorAll('img')) : [];
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
  function galIndex() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
  function galGo(i, smooth) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    markThumb(i);
  }
  function markThumb(i) {
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    var t = thumbs[i];
    if (t && t.parentNode) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
  }
  if (track) {
    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { markThumb(galIndex()); }, 80); }, { passive: true });
    root.querySelectorAll('[data-lnb-dir]').forEach(function (b) {
      b.addEventListener('click', function () { galGo(galIndex() + parseInt(b.getAttribute('data-lnb-dir'), 10)); });
    });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { galGo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
  }
  function galToMedia(id, smooth) {
    for (var k = 0; k < slides.length; k++) if (slides[k].getAttribute('data-media') === String(id)) { galGo(k, smooth); return; }
  }

  /* set cards */
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-lnb-v]'));
  var idInput = root.querySelector('[data-lnb-id]');
  var submit = root.querySelector('#lnb-form [type=submit]');
  function pick(card, push, smooth) {
    cards.forEach(function (c) { var on = c === card; c.classList.toggle('is-on', on); c.setAttribute('aria-checked', on ? 'true' : 'false'); });
    if (idInput) idInput.value = card.getAttribute('data-lnb-v');
    root.querySelectorAll('[data-lnb-now]').forEach(function (e) { e.textContent = card.getAttribute('data-price'); });
    root.querySelectorAll('[data-lnb-was]').forEach(function (e) { e.textContent = card.getAttribute('data-compare'); });
    root.querySelectorAll('[data-lnb-save]').forEach(function (e) { e.textContent = 'Save ' + card.getAttribute('data-save') + '%'; });
    root.querySelectorAll('[data-lnb-atc]').forEach(function (e) { e.textContent = card.getAttribute('data-price'); });
    var opt = card.getAttribute('data-opt');
    root.querySelectorAll('[data-lnb-box]').forEach(function (e) { e.hidden = e.getAttribute('data-lnb-box') !== opt; });
    if (submit) submit.disabled = card.getAttribute('data-available') !== 'true';
    var m = card.getAttribute('data-media'); if (m) galToMedia(m, smooth);
    if (push && window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', card.getAttribute('data-lnb-v')); history.replaceState(null, '', u.toString());
    }
  }
  cards.forEach(function (c) { c.addEventListener('click', function () { pick(c, true, true); }); });
  var on = root.querySelector('[data-lnb-v].is-on');
  if (on && /[?&]variant=/.test(location.search)) pick(on, false, false);

  /* bundle box -> Complete Set */
  root.querySelectorAll('[data-lnb-bundle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var id = b.getAttribute('data-lnb-bundle');
      var card = cards.filter(function (c) { return c.getAttribute('data-lnb-v') === id; })[0];
      if (card) pick(card, true, false);
      var f = document.getElementById('lnb-form');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.querySelector('[type=submit]').click(); }
    });
  });

  /* scroll to buy box */
  root.querySelectorAll('[data-lnb-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById('lnb-buy'); if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
    });
  });

  /* carousels */
  root.querySelectorAll('[data-lnb-car]').forEach(function (car) {
    var tr = car.querySelector('.lnb-car__track'); if (!tr) return;
    var items = tr.children, dots = car.querySelector('.lnb-car__dots');
    function step() { return items.length ? items[0].getBoundingClientRect().width + 12 : tr.clientWidth; }
    function pages() { return Math.max(1, Math.round((tr.scrollWidth - tr.clientWidth) / step()) + 1); }
    function draw() {
      if (!dots) return;
      var n = pages(), cur = Math.round(tr.scrollLeft / step());
      if (dots.children.length !== n) dots.innerHTML = new Array(n + 1).join('<span></span>');
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === Math.min(cur, n - 1)); });
    }
    car.querySelectorAll('[data-car]').forEach(function (b) {
      b.addEventListener('click', function () { tr.scrollBy({ left: parseInt(b.getAttribute('data-car'), 10) * step(), behavior: 'smooth' }); });
    });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(draw); }, { passive: true });
    window.addEventListener('resize', draw);
    draw();
  });

  /* click-to-play videos */
  root.querySelectorAll('.lnb-vid-wrap').forEach(function (w) {
    var vid = w.querySelector('video'), btn = w.querySelector('.lnb-play');
    if (!vid || !btn) return;
    btn.addEventListener('click', function () { vid.muted = false; vid.play(); w.classList.add('is-playing'); vid.setAttribute('controls', ''); });
  });
})();
